/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductSubBrandResponseDto
 */
export interface ProductSubBrandResponseDto {
    /**
     * Sub-brand ID
     * @type {number}
     * @memberof ProductSubBrandResponseDto
     */
    id: number;
    /**
     * Sub-brand name/code
     * @type {string}
     * @memberof ProductSubBrandResponseDto
     */
    name: string;
    /**
     * Brand ID this sub-brand belongs to
     * @type {number}
     * @memberof ProductSubBrandResponseDto
     */
    brandId: number;
}

/**
 * Check if a given object implements the ProductSubBrandResponseDto interface.
 */
export function instanceOfProductSubBrandResponseDto(value: object): value is ProductSubBrandResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('brandId' in value) || value['brandId'] === undefined) return false;
    return true;
}

export function ProductSubBrandResponseDtoFromJSON(json: any): ProductSubBrandResponseDto {
    return ProductSubBrandResponseDtoFromJSONTyped(json, false);
}

export function ProductSubBrandResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductSubBrandResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'brandId': json['brandId'],
    };
}

export function ProductSubBrandResponseDtoToJSON(value?: ProductSubBrandResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'brandId': value['brandId'],
    };
}

